import styled from "styled-components";
import BlueButton from './blueButton'
import { darken } from 'polished';

const SOrangeButton = styled(BlueButton)`
    background-color: #F2A516;
    box-shadow: 0 2px 8px rgba(242,165,22,0.30);
    color: #1B2F50;
    font-weight: 700;

    &:hover {
        background-color: ${darken(0.08, '#F2A516')};
        box-shadow: 0 4px 16px rgba(242,165,22,0.40);
    }

    &:active {
        background-color: ${darken(0.15, '#F2A516')};
    }
`;

export default SOrangeButton;
